import React, {useContext} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import { Link } from "react-router-dom";
import SchoolContext from "../../Context/SchoolContext";
import AddTerm from "../../Components/Settings/SchoolTerm/AddTerm";
import UpdateTermDetails from "../../Components/Settings/SchoolTerm/UpdateTermDetails";
import ActivateTerm from "../../Components/Settings/SchoolTerm/ActivateTerm";
import useStateCallback from "../../util/customHooks/useStateCallback";

function TermsPage() {
  const {schoolTermList, getTermsList} = useContext(SchoolContext);
  const [modal, setModal] = useStateCallback(false);
  const refreshData = () =>{
    getTermsList()
  }

  const updateTerm=(e,item)=>{
        setModal(false, ()=>setModal(<UpdateTermDetails termID={item.term_id} startDate={item.start_date} endDate={item.end_date} g={getTermsList} isOpen={true}/>))
    }

    const activateTerm=(e,item)=>{
        setModal(false, ()=>setModal(<ActivateTerm termID={item.term_id} g={getTermsList} isOpen={true}/>))
    }

  return (
    <AppContainer title="School Terms">
      {modal}
      <div className="row">
        <div className="col-lg-4">
          <AddTerm/>
        </div>
        <div className="col-lg-8">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                <TableHeader
                  title="School Terms List"
                  subtitle="List of all the school terms sorted in ascending order"
                />
                <div class="dropdown">
                                        <Link class="dropdown-toggle" role="button" 
                                        data-toggle="dropdown" aria-expanded="false">...</Link>
                
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                                        </div>
                                    </div>
              </div>

              <div className="table-responsive">
                <table className="table table-hover text-nowrap mg-b-0">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Term Name</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Status</th>
                      <th>Actions</th>

                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(schoolTermList) && schoolTermList.map((item, key) => (
                        <tr>
                          <td>{key + 1}</td>
                          <td>{item.term_name} </td>
                          <td>{item.start_date_fmt?.short_date} </td>
                          <td>{item.end_date_fmt?.short_date} </td>
                          <td>{item.is_active === "Active" ? <span class="badge badge-success">ACTIVE </span>:""}</td>
                          <td>
                                                  <div className="dropdown">
                                                      <Link
                                                      to="#"
                                                      className="dropdown-toggle"
                                                      data-toggle="dropdown"
                                                      aria-expanded="false">
                                                      <span className="flaticon-more-button-of-three-dots"></span>
                                                      </Link>
                                                      <div className="dropdown-menu dropdown-menu-right">
                                                      <Link
                                                          className="dropdown-item"
                                                          to="#"
                                                          onClick={(e) => updateTerm(e,item)}>
                                                          <i className="far fa-edit mr-1" style={{color:"green"}}></i>
                                                          Update Term Details
                                                      </Link>
                                                      {item.is_active === "Inactive" && (
                                                          <Link
                                                              className="dropdown-item"
                                                              to="#"
                                                              onClick={(e) => activateTerm(e,item)}>
                                                              <i className="far fa-edit mr-1" style={{color:"green"}}></i>
                                                              Activate Term
                                                          </Link>
                                                      )}
                                                      
                                                      </div>
                                                  </div>
                                              </td>
                        </tr>
                      ))}
                      {schoolTermList === "404" && (<tr>
                          <td colSpan="5" style={{textAlign: "center"}}>
                            No school terms registered yet.
                          </td>
                        </tr>)}
                  </tbody>
                </table>
                {!schoolTermList && <Loader />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default TermsPage;
